<template>
  <account-layout>
    <el-row :gutter="60">
      <el-col :span="24" class="row-space">
        <div>Email</div>
        <el-form :model="resetPassword" :rules="rules" ref="form" @submit.native.prevent="onSubmit">
          <el-form-item prop="email">
            <el-input v-model="resetPassword.email" class="input-space" type="email" placeholder="Type here..." />
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row class="row-space">
      <el-col :span="24">
        <el-button
          type="primary"
          class="ac-btn"
          @click="reset"
        >Reset Password</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" class="align-center">
        <el-button type="text" @click="login">Return to Login</el-button>
      </el-col>
    </el-row>
  </account-layout>
</template>

<script>
import AccountLayout from './AccountLayout.vue';

export default {
  name: 'AccountReset',
  components: {
    AccountLayout
  },
  props: {
    platform: String
  },
  data() {
    const checkEmail = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Email is required'));
      }
      const re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
      if (re.test(String(value).toLowerCase())) return callback();
      return callback(new Error('Invalid email address'));
    };

    return {
      resetPassword: {
        email: undefined,
      },
      rules: {
        email: [
          { validator: checkEmail, trigger: 'blur' }
        ],
      }
    };
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();
      this.reset();
    },
    reset() {
      this.$refs.form.validate()
        .then((val) => {
          if (!val) return;
          this.$store.commit('loading', { loading: true, text: 'Loading...' });
          this.$httpNoAuth.post(`assemble/api/v1/account/${this.platform}/reset`, this.resetPassword)
            .then(() => {
              this.$message.success('Email sent successfully');
              this.$store.commit('loading', false);
            }).catch((e) => {
              this.$message.error(e.response.data.message);
              this.$store.commit('loading', false);
            });
        })
        .catch(() => {});
    },
    login() {
      this.$router.push('login');
    }
  }
};
</script>

<style scoped lang="scss">
.content-card {
  margin-left: 1em;
  margin-right: 1em;
  margin-top: 2em;
  width: 90%;
  max-width: 30em;
}

.align-center {
  text-align: center;
}

.row-space {
  margin-top: 1em;
}

.input-space {
  margin-top: 0.5em;
}

.ac-btn {
  width: 100%;
  background-color: $highlight !important;
  border: 0;
}
</style>
